export default {
  summary_one: '{{count}} tuote poistettiin · ei saatavilla noutoaikanasi',
  summary_other: '{{count}} tuotetta poistettiin · ei saatavilla noutoaikanasi',
  reason: 'Tilattavissa vain {{schedule}} — noutoaikasi on {{time}}.',
  change_pickup_time: 'Vaihda noutoaikaa',
  dismiss: 'Hylkää',
};
